/**
 * Sizing tokens come from Slate 1 sizing
 * https://slate.faire.team/foundations/icons/design#sizing
 * TODO: Use Semantic Dimension tokens from Slate 2:
 * https://www.figma.com/design/jQPqQpDxUlUrVD9oS897Ti/Slate-Foundations?node-id=2-155&p=f&vars=1&m=dev
 */
export enum Sizing {
  SIZING_UNKNOWN = 'SIZING_UNKNOWN',
  /**
   * 16x16px
   */
  SIZING_S = 'SIZING_S',
  /**
   * 24x24px
   */
  SIZING_M = 'SIZING_M',
  /**
   * 32x32px
   */
  SIZING_L = 'SIZING_L',
}
